<template>
    <v-chart class="chart__display" :option="option" autoresize/>
</template>

<script>

import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import VChart from 'vue-echarts';
import { ref, defineComponent } from 'vue';

use([
  CanvasRenderer,
  PieChart,
]);

export default defineComponent({
  name: 'PieChart',
  components: {
    VChart
  },
  props: ['value'],
  setup(props) {
    const option = ref({
      series: [{
        type: 'pie',
        radius: '100%',
        label: {show: false},
        data: [
          { value: props.value, itemStyle: {color: '#004D85'}},
          { value: 100 - props.value, itemStyle: {color: '#ffffff'}},
        ],
      }]
    });

    return { option };
  },
})
</script>